import { ApiStatus } from '../../types';
import { LiabilitiesTemplate } from '../../utils/displayLiabilitiesFields';

export const commbankLiabilitiesDefaultContent = {
    'heading': '{heading placeholder}',
    'description': '{description placeholder}',
    'confirmButtonText': '{confirmButtonText placeholder}',
    'confirmButtonErrorMessage': '{confirmButtonWarningMessage}',
    'editLiabilitiesButtonText': '{Edit}',
    'balanceLabel': '{accountBalanceLabel}',
    'creditLimitLabel': '{accountCreditLimitLabel}',
    'repaymentLabel': 'accountRepaymentLabel',
    'shareRepaymentLabel': 'accountShareRepaymentLabel',
    'editShareRepayment': {
        'confirmButtonText': '{confirmShareAmountText}',
        'cancelButtonText': '{cancelShareAmountText}',
        'question': {
            'label': '{Share monthly repayment amount label}',
            'percentage': '50',
            'options': [
                {
                    'key': '{share repayment answer agree}',
                    'value': 'agree',
                },
                {
                    'key': '{share repayment answer disagree}',
                    'value': 'disagree',
                },
            ],
        },
        'amount': {
            'label': '{ShareRepaymentAmount label}',
            'placeholder': '{$}',
        },

    },
    'validations': {
        'hardValidations': {
            'editShareRepayment': {
                'question': {
                    'defaultErrorMessage': '{shareRepayment missing question default error message}',
                },
                'amount': {
                    'minValue': '0.01',
                    'defaultErrorMessage': '{shareRepaymentAmount defaultErrorMessage}',
                    'minValueMessage': '{ShareRepaymentAmount minValueMessage}',
                    'maxValueMessage': '{shareRepaymentAmount maxValueMessage}',
                },
                'confirmButtonText': {
                    'defaultErrorMessage': '{confirmButtonDefaultErrorMessage}',
                },
            },
        },
    },
};

export type CommbankLiabilitiesContent = typeof commbankLiabilitiesDefaultContent;
export type CommbankLiabilitiesEndpoints = {
    getCommbankLiabilitiesUrl: string,
    updateCommbankLiabilitiesUrl?: string
}

export type UpdateCommbankLiabilitiesEndpoints = {
    getCommbankLiabilitiesUrl?: string,
    updateCommbankLiabilitiesUrl?: string
}

export type UpdateCommbankLiabilityPayload = {
    repaymentShare: string;
    liabilityId: number;
};

export type CommbankLiabilitiesState = {
    content: CommbankLiabilitiesContent;
    getCommbankLiabilitiesAPIStatus: ApiStatus;
    updateCommbankLiabilitiesAPIStatus: ApiStatus;
    apiEndpoints: CommbankLiabilitiesEndpoints;
    commbankLiabilitiesDetails: CommbankLiabilitiesItem[];
    updateCommbankLiabilitiesPayload: UpdateCommbankLiabilityPayload[];
}

export type CommbankLiabilitiesItem = {
    liabilityTypeDescription: string;
    currentBalance: string;
    creditLimit: string;
    repaymentAmount: string;
    liabilityId: number;
    liabilityGroup: LiabilitiesTemplate;
    accountNumber: string;
    repaymentShare: string | null;
    ownershipShare: string;
    isShareLiability: boolean;
}

export type FetchCommbankLiabilitiesPayload = {
    content: string,
    commbankLiabilities: CommbankLiabilitiesItem[]
}
